<template>
    <div>
        <form class="form filters">
            <div class="row" v-if="counselors.length > 1">
                <div class="col-12">
                    <div class="form__item">
                        <i class="form__icon icons icon-user"></i>
                        <vue-select  class="form__select" v-model="counselorFilter" :options="counselorFilterOptions" label="name" :class="{ 'has-value': counselorFilter }"></vue-select>
                        <label class="form__label">{{$t('forms.trajectory.counselor')}}</label>
                    </div>
                </div>
            </div>
        </form>
        <div class="table__responsive">
            <table class="table">
                <thead v-if="!loadingTrajectories  && trajectories.length">
                    <tr>
                        <th>{{$t('trajectories.table.header.advisor')}}</th>
                        <th>{{$t('trajectories.table.header.client')}}</th>
                        <th>{{$t('trajectories.table.header.contact_name')}}</th>
                        <th>{{$t('trajectories.table.header.status')}}</th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-if="loadingTrajectories" :key="'loading'" class="table--loading">
                        <td colspan="5">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('trajectories.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingTrajectories && !trajectories.length" :key="'no-trajectories'" class="table--empty">
                        <td colspan="5">
                            <div class="text-center">{{$t('trajectories.table.no_trajectories')}}</div>
                        </td>
                    </tr>
                    <tr v-for="trajectory in trajectories" :key="trajectory.id" @click="navigateToTrajectory(trajectory)">
                        <td>{{ trajectory.counselor.name }}</td>
                        <td>{{ trajectory.client.name }}</td>
                        <td>{{ trajectory.contact_name }}</td>
                        <td>{{ trajectory.trajectory_state.name | capitalize }}</td>
                        <td><span @click="navigateToTrajectory(trajectory)" v-tooltip.right="$t('trajectories.table.view')" class="table__icon icons icon-eye"></span></td>
                    </tr>

                    <tr class="table__navigation" v-if="trajectoriesMeta && trajectoriesMeta.last_page > 1">
                        <td colspan="5">
                            <pagination :meta="trajectoriesMeta" @goToPage="goToPage"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Watch } from 'vue-property-decorator';
    import Pagination from '@/components/tables/Pagination';
    import { LOAD_TRAJECTORY_RESOURCES } from '@/store/modules/trajectory-resources';
    import { GET_TRAJECTORIES } from '@/store/modules/trajectories';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class TrajectoriesTable extends Vue {
        name = 'trajectories-table';
        counselorFilter = null;
        allCounselorsOption = { name:'All counselors placeholder', id: -1 };
        mounted() {
            this.allCounselorsOption.name = this.$t('trajectories.table.all_counselors');
            this.counselorFilter = this.allCounselorsOption;

            this.$store.dispatch(LOAD_TRAJECTORY_RESOURCES);
            this.$store.dispatch(GET_TRAJECTORIES, {});
        }

        get trajectories() {
            return this.$store.state.trajectories.trajectories;
        }

        get loadingTrajectories() {
            return this.$store.state.trajectories.loading;
        }

        get trajectoriesMeta() {
            return this.$store.state.trajectories.trajectoriesMeta;
        }

        get counselors() {
            return this.$store.state.trajectory_resources.counselors;
        }

        get counselorFilterOptions() {
            return [this.allCounselorsOption, ...this.counselors];
        }

        @Watch('counselorFilter', { })
        filterByCounselor(counselor) {
            this.$store.dispatch(GET_TRAJECTORIES, { params: { counselor: counselor.id >= 0 ? this.counselorFilter.id : null, page: 1 }});
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_TRAJECTORIES, { params: { counselor: this.counselorFilter && this.counselorFilter.id >= 0 ? this.counselorFilter.id : null, page: pageNo }});
        }

        navigateToTrajectory(trajectory) {
            this.$router.push({ name: 'dashboard', params: { id: trajectory.id }});
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/trajectories/TrajectoriesTable.vue